import {ReactElement, useMemo, useState, CSSProperties, useEffect} from 'react';
import Slider from 'rc-slider';
import LockIconSvg from '../LockIconSvg';

const trackStyle: CSSProperties = {
  backgroundColor: '#f73400',
  height: '10px',
  border: 'none',
  boxShadow: 'none',
  marginTop: '-9px',
};
const railStyle: CSSProperties = {
  ...trackStyle,
  backgroundColor: '#d8d8d8',
};

const handleStyle: CSSProperties = {
  width: '20px',
  height: '20px',
  marginTop: '-15px',
  border: 'solid 4px #f73400',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  boxShadow: 'none',
  cursor: 'pointer',
  transform: 'none',
  position: 'relative',
};

interface NumberInputSliderFieldProps {
  onChange: (name: string, value: string | number) => void;
  name: string;
  value: number | string;
  min: number;
  max: number;
  step: number;
  labelClassName?: string;
  label?: string;
  error?: string;
  hidden?: boolean;
  disabled?: boolean;
}

export default function NumberInputSliderField({
  name,
  value,
  min = 1,
  max = 100,
  step = 1,
  labelClassName,
  label,
  error,
  onChange,
  hidden = false,
  disabled = false,
}: NumberInputSliderFieldProps): ReactElement {
  const hasError = useMemo(() => !!error, [error]);
  const [sliderValue, setSliderValue] = useState<string | number>('');

  useEffect(() => {
    if (value) setSliderValue(value);
  }, [value]);

  useEffect(() => {
    if (sliderValue && sliderValue !== value) {
      onChange(name, sliderValue);
    }
  }, [name, onChange, sliderValue, value]);

  return (
    <label
      className={labelClassName}
      style={{display: hidden ? 'none' : 'block'}}
    >
      {label && (
        <span>
          {label}
          {disabled && <LockIconSvg />}
        </span>
      )}
      <Slider
        className="mt-20"
        min={min}
        max={max}
        value={sliderValue as number}
        onChange={setSliderValue}
        step={step}
        handleStyle={handleStyle}
        trackStyle={trackStyle}
        railStyle={railStyle}
        disabled={disabled}
      />
      <p>{sliderValue ? `${sliderValue}%` : ''}</p>
      {hasError && <p className="error-msg">{error}</p>}
    </label>
  );
}
